import api from './api';

// Serviço para gerenciar permissões
export const permissaoService = {
  // Listar permissões com paginação e filtros
  async list(params = {}) {
    try {
      const response = await api.get('/permissoes', { params });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar permissões');
    }
  },

  // Buscar permissão por ID
  async getById(id) {
    try {
      const response = await api.get(`/permissoes/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar permissão');
    }
  },

  // Criar permissão
  async create(permissaoData) {
    try {
      const response = await api.post('/permissoes', permissaoData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao criar permissão');
    }
  },

  // Atualizar permissão
  async update(id, permissaoData) {
    try {
      const response = await api.put(`/permissoes/${id}`, permissaoData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao atualizar permissão');
    }
  },

  // Deletar permissão
  async delete(id) {
    try {
      const response = await api.delete(`/permissoes/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao excluir permissão');
    }
  },

  // Alterar status da permissão
  async changeStatus(id, ativo) {
    try {
      const response = await api.patch(`/permissoes/${id}/status`, { ativo });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao alterar status da permissão');
    }
  },

  // Buscar módulos disponíveis
  async getModules() {
    try {
      const response = await api.get('/permissoes/modulos');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar módulos');
    }
  },

  // Buscar ações disponíveis
  async getActions() {
    try {
      const response = await api.get('/permissoes/acoes');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar ações');
    }
  },

  // Buscar estatísticas de permissões
  async getStats() {
    try {
      const response = await api.get('/permissoes/stats');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar estatísticas');
    }
  },

  // Buscar todas as permissões (sem paginação)
  async getAll() {
    try {
      const response = await api.get('/permissoes/all');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar todas as permissões');
    }
  },

  // Buscar permissões agrupadas por módulo
  async getByModule() {
    try {
      const response = await api.get('/permissoes/by-module');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erro ao buscar permissões por módulo');
    }
  }
};

export default permissaoService;
